var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpgradeProfileBenefits3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.492289,
    y: 1.32649,
    width: 16.3752,
    height: 16.4995,
    transform: "matrix(0.908751 0.417338 -0.416462 0.909153 17.577 0.915056)",
    fill: "#C7DFF2",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.80847,
    y: 5.47827,
    width: 18.8696,
    height: 24.4348,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1557 29.5003C15.4047 29.501 14.6733 29.2646 14.0693 28.826V33L16.1563 31.7386L18.2432 33V28.826C17.6389 29.265 16.9071 29.5013 16.1557 29.5003Z",
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1564 29.5218C18.0774 29.5218 19.6346 27.9646 19.6346 26.0436C19.6346 24.1226 18.0774 22.5653 16.1564 22.5653C14.2354 22.5653 12.6781 24.1226 12.6781 26.0436C12.6781 27.9646 14.2354 29.5218 16.1564 29.5218Z",
    fill: "#6CA5D4",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9824,
    y: 10.0435,
    width: 13.2174,
    height: 1.3913,
    rx: 0.695652,
    fill: "#413D45"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9824,
    y: 13.5217,
    width: 13.2174,
    height: 1.3913,
    rx: 0.695652,
    fill: "#413D45"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9824,
    y: 17,
    width: 7.65217,
    height: 1.3913,
    rx: 0.695652,
    fill: "#413D45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgradeProfileBenefits3);
export default __webpack_public_path__ + "static/media/icon-upgrade-profile-benefits-3.9cc0af450a07fe8b5a8df48124ef1969.svg";
export { ForwardRef as ReactComponent };